import { FeedbackContent } from '@dynamic-components/feedback/feedback.type';

export const MOCK_FEEDBACK_CONTENT: FeedbackContent = {
  title: 'Did you find what you needed?',
  positiveButtonLabel: 'Yes',
  negativeButtonLabel: 'No',
  submittedTitle: [{ content: 'Thanks for your feedback!' }],
  starRatingHeader: 'Yes',
  negativeFeedbackTitle: 'Tell us a little more',
  negativeFeedbackDescription: 'Please select all that apply.',
  submitButton: 'Submit',
  negativeCheckboxLabels: [
    'This info is confusing or unclear',
    "These instructions didn't work",
    "I didn't find the answer to my question",
    'Something else',
  ],
  label: 'Comments',
  description: 'Comments',
};
